var map = {
	"./block-categories-grid/_index.scss": 5739,
	"./block-category-line/_index.scss": 4243,
	"./block-faq/_index.scss": 3313,
	"./block-feedback/_index.scss": 6994,
	"./block-hero/_index.scss": 206,
	"./block-map/_index.scss": 8557,
	"./block-new-products/_index.scss": 2956,
	"./block-popular-products/_index.scss": 1919,
	"./block-promo/_index.scss": 7657,
	"./block-switcher/_index.scss": 3221,
	"./block-white-wrapper/_index.scss": 5607,
	"./block-wrapper-gray/_index.scss": 3522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8109;